<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          v-model="studentSearch"
          @focus="focusStudent = true"
          @blur="focusStudent = false"
          label="Student No. or Name"
          filled
          hide-details
        ></v-text-field>
      </v-col>
      <v-col class="flex-shrink-1 flex-grow-0 d-flex px-0">
        <v-icon class="align-self-center">
          {{ mdiArrowLeftRight }}
        </v-icon>
      </v-col>
      <v-col>
        <v-text-field
          v-model="cadaverSearch"
          @focus="focusCadaver = true"
          @blur="focusCadaver = false"
          label="Cadaver P"
          filled
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <template v-if="studentResult">
          <p>
            Name:
            {{
              `${studentResult.nick} ${studentResult.name} ${studentResult.surname}`
            }}
          </p>
          <p>Tel: {{ studentResult.tel }}</p>
          <p>Line: {{ studentResult.line }}</p>
          <p>Email: {{ studentResult.email }}</p>
        </template>
      </v-col>
      <v-col>
        <template v-if="cadaverResult">
          <p>
            Name:
            {{
              `${cadaverResult.title}${cadaverResult.name} ${cadaverResult.surname}`
            }}
          </p>
          <p>
            Relative:
            {{
              `${cadaverResult.relative.title}${cadaverResult.relative.name} ${cadaverResult.relative.surname}`
            }}
          </p>
          <p>Main Contact: {{ cadaverResult.mainContact }}</p>
          <p>
            Tels:
            {{ cadaverResult.tels.map(tel => `${tel.tel} (${tel.name || "-"})`).join(", ") }}
          </p>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/// <reference path="../../types/cadavers.d.ts" />
/// <reference path="../../types/students.d.ts" />

import { mdiArrowLeftRight } from "@mdi/js";

export default {
  name: "FindStudent",
  props: ["cadavers", "students"],
  data: () => ({
    studentSearch: "",
    cadaverSearch: "",
    focusStudent: false,
    focusCadaver: false,
    mdiArrowLeftRight
  }),
  watch: {
    studentSearch(value) {
      if (!this.focusStudent) return;
      if (value.length === 0) {
        this.cadaverSearch = "";
        return;
      }
    },
    cadaverSearch(value) {
      if (!this.focusCadaver) return;
      if (value.length != 3) {
        this.studentSearch = "";
        return;
      }
      /** @type Students */
      const students = this.students;
      const email = Object.keys(students).find(
        email =>
          students[email].firstContact &&
          students[email].firstContact.includes(value)
      );
      if (email) {
        this.studentSearch = students[email].number.toString();
      }
    },
    studentResult(value) {
      if (value && value.firstContact) {
        this.cadaverSearch = value.firstContact.substring(1);
      } else if (!this.focusCadaver) {
        this.cadaverSearch = "";
      }
    }
  },
  computed: {
    studentResult() {
      if (this.studentSearch.length > 0) {
        /** @type Students */
        const students = this.students;
        const email = Object.keys(students).find(
          email =>
            students[email].number.toString() === this.studentSearch ||
            (
              students[email].nick +
              " " +
              students[email].name +
              " " +
              students[email].surname
            ).includes(this.studentSearch)
        );
        if (email) {
          return { email, ...students[email] };
        }
      }
      return null;
    },
    cadaverResult() {
      if (this.cadaverSearch.length != 3) return null;
      return this.cadavers[`P${this.cadaverSearch}`];
    }
  }
};
</script>
